import { Company, Country, UserEntityLinkRole } from '@prisma/client';
import { IEvent } from '../../../api/cal-com/calCom.types';
import { Timezone } from '../timezone';

export type AddUserToCompanyFromAdminProps = {
  textOfExplanation: string;
  contextLink?: string;
  isTemporaryAccess: boolean;
  user: AddUserToCompanyProps;
};

export type AddUserToCompanyProps = {
  name: string;
  email: string;
  role: UserEntityLinkRole;
};

export type LoggedInUserInfo = {
  id: string;
  name: string;
  email: string;
  dateOfBirth?: string;
  company?: Company;
  companyId?: number;
  additionalInfo?: UserAdditionalInformation;
  image: string;
  timeZone: Timezone;

  calComUserName: string; // This is the unique slug for calendar links

  calComData?: {
    accessToken: string;
    id: number;
  };
  userAdditionalInformation?: UserAdditionalInformation;
  phoneNumber?: string;
  serviceRequestMetaData?: {
    hasSeenServiceRequestV2?: boolean;
  };
  hasSeenProductRevampIntroBanner: boolean;
  isCommendaAdmin?: boolean;
  isCommendaSuperAdmin?: boolean;
};

export enum RoleInOrganization {
  CEO_FOUNDER = 'CEO_FOUNDER',
  GENERAL_COUNSEL = 'GENERAL_COUNSEL',
  COMPLIANCE_OFFICER = 'COMPLIANCE_OFFICER',
  FINANCE_TAX_MANAGER = 'FINANCE_TAX_MANAGER',
  CORPORATE_SECRETARY = 'CORPORATE_SECRETARY',
  OPERATIONS_MANAGER = 'OPERATIONS_MANAGER',
  HR_PAYROLL_MANAGER = 'HR_PAYROLL_MANAGER',
  AUDITOR_CONSULTANT = 'AUDITOR_CONSULTANT',
  OTHER = 'OTHER',
}

export interface UserAdditionalInformation {
  phoneNumber: string;
  roleInOrganization?: RoleInOrganization;
}

export interface IUserCalendar {
  id: string; // userId

  avatar: string; // avatar image as base64
  name: string; // username
  calComUserName: string; // calcom username
  position: string; // current position at CAfirm
  certificates: string[];

  caFirm: {
    id: string;
    name: string;
    description: string;
    supportedMarkets: Country[];
  };

  events: IEvent[];
}
